import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store/index";
//引入vant
import Vant from "vant";
import "vant/lib/index.css";

Vue.use(Vant);

// 引入mockjs模拟接口数据
import mockjs from "@/assets/js/mock.js";
Vue.use(mockjs);

// import "@/register-service-worker";
import { Toast, Popup, Spinner, Loadmore } from "mint-ui";

// 引入mint-ui
import "mint-ui/lib/style.css";

// 把 api 挂载到 Vue 原型对象上
import * as api from "@/assets/js/api";

// 注册filter
import * as filters from "@/filter";
import * as storage from "@/assets/js/storage";

// 引入element
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);

// 全局引入小人组件
import CartoonKid from "./views/cartoon-kid/index.vue";
import "@/common/cartoon-kid-event-store";
Vue.use(CartoonKid);

import Cookies from "js-cookie";

import "@/permission"; // 前置守卫
// 引入电子签名
import vueEsign from "vue-esign";
Vue.use(vueEsign);

// 引入
import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);


// import { setOpenId , registerWxConfig } from "@/weixinConfig";
// if(!localStorage.getItem("appid")){
//   registerWxConfig()
// }

// if (!sessionStorage.getItem("openid") && localStorage.getItem("appid")) {
//   setOpenId("0");
// }

// mint-ui组件按需加载,全局注册
window.Toast = Toast;
Vue.component(Popup.name, Popup);
Vue.component(Spinner.name, Spinner);
Vue.component(Loadmore.name, Loadmore);

Object.keys(filters).map((item) => {
  Vue.filter(item, filters[item]);
});
Vue.prototype.$http = api;
Vue.prototype.$storage = storage;
Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
